import { render, staticRenderFns } from "./uploadSingleImg.vue?vue&type=template&id=55dc4091"
import script from "./uploadSingleImg.vue?vue&type=script&lang=js"
export * from "./uploadSingleImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports